import { render, staticRenderFns } from "./HeatmapAvgFold.vue?vue&type=template&id=81256dd8"
import script from "./HeatmapAvgFold.vue?vue&type=script&lang=js"
export * from "./HeatmapAvgFold.vue?vue&type=script&lang=js"
import style0 from "./HeatmapAvgFold.vue?vue&type=style&index=0&id=81256dd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports